import React, {useCallback, useRef, useState} from "react";
import {Row} from "reactstrap";
import Dialog from "../../base/dialog";
import Button from "../../base/button/button";
import useIsMounted from "../../../hooks/use-is-mounted";
import {DialogActions, DialogContent, DialogTitle} from "@mui/material";
import SendOrderEmail, {SendOrderEmailTextTypes} from "../../app-specific/send-order-email";
import {createUUId} from "../../../../core/services/utils/utils";


const SendOrderEmailDialog = ({
                                  open,
                                  close,
                                  customerId,
                                  send
                              }) => {
    const [submitting, setSubmitting] = useState(false);
    const isMounted = useIsMounted();
    const formIdRef = useRef(createUUId(true));

    /**
     * Submits the form with the given email value to be sent to the api
     * @param values
     */
    const onSubmit = useCallback(async (values) => {
        if (!values?.email || !send)
            return;
        setSubmitting(true);
        const resultFlag = await send(values.email, values.includeBcc);
        if (!isMounted())
            return;
        setSubmitting(false)
        if (resultFlag) {
            close();
        }
    }, [send, close, isMounted]);

    return (
        <Dialog
            open={open}
            setOpen={close}
            maxWidth={'sm'}
            className={'bound-dialog'}
        >
            <DialogTitle>
                <Row xs={12} className='no-gutters justify-content-center m-3'>
                    <p className={`text-lg text-color-1 my-2 font-weight-semi-bold text-center`}>
                        Send Order Email
                    </p>
                </Row>
            </DialogTitle>
            <DialogContent dividers>
                <SendOrderEmail
                    customerId={customerId}
                    submit={onSubmit}
                    textType={SendOrderEmailTextTypes.orderInfo}
                    formId={formIdRef.current}
                />
            </DialogContent>
            <DialogActions className={'d-flex align-items-center justify-content-between w-100'}>
                <Button
                    disabled={!open || submitting}
                    variant={'dialog'}
                    color={'primary'}
                    onClick={() => close()}
                    borderRadius={'0 8px 0 8px'}
                >
                    {submitting ? 'submitting...' : 'Close'}
                </Button>
                <Button
                    disabled={!open || submitting}
                    variant={'dialog'}
                    color={'primary'}
                    type={'submit'}
                    form={formIdRef.current}
                    borderRadius={'8px 0 8px 0'}
                >
                    {submitting ? 'submitting...' : 'Send'}
                </Button>
            </DialogActions>
        </Dialog>
    );

}

export default SendOrderEmailDialog;
